import {createReducer} from '@reduxjs/toolkit'
import {getComponentData} from '../actions/component'
import {Events} from '../types/state'
import {detailedEvents} from './events'

const defaultState: Events = {
  past: [],
  upcoming: [],
  total: {
    past: 0,
    upcoming: 0,
  },
  error: false,
}

export const demoEvents = createReducer(defaultState, builder => {
  builder
    .addCase(getComponentData.fulfilled, (state, action) => {
      if (action.payload.demoData) {
        const {events, orders, rsvps} = action.payload.demoData

        if (events) {
          const past = [...state.past, ...detailedEvents(events, orders, rsvps)]
          const upcoming = [...state.upcoming, ...detailedEvents(events, orders, rsvps)]

          state.past = past
          state.upcoming = upcoming
          state.total.past = past.length
          state.total.upcoming = upcoming.length
          state.error = false
        }
      }
    })
    .addCase(getComponentData.rejected, state => {
      state.error = true
    })
})
